export enum RealTimeConnectionStatus {
   DISCONNECTED,
   CONNECTING,
   CONNECTED,
}
